module.exports = __webpack_public_path__ + "img/h_marshal_main.jpg";